module.exports = __webpack_public_path__ + "img/titleTwo3.2cca7e5e.png";